import React from "react";
import { Card, Row, Col, Statistic, Skeleton } from "antd";
import { ClockCircleOutlined, ExclamationCircleOutlined, CheckCircleOutlined, CalendarOutlined } from "@ant-design/icons";

interface TaskStatsData {
  activeTasks: number;
  overdueTasks: number;
  todayTasks: number;
  weekTasks: number;
}

interface TaskStatsProps {
  data?: TaskStatsData;
  loading: boolean;
}

const TaskStats: React.FC<TaskStatsProps> = ({ data, loading }) => {
  if (loading) {
    return (
      <Card title="Статистика задач">
        <Row gutter={16}>
          <Col xs={12} sm={6}>
            <Skeleton.Input active size="small" style={{ width: '100%', height: 40 }} />
          </Col>
          <Col xs={12} sm={6}>
            <Skeleton.Input active size="small" style={{ width: '100%', height: 40 }} />
          </Col>
          <Col xs={12} sm={6}>
            <Skeleton.Input active size="small" style={{ width: '100%', height: 40 }} />
          </Col>
          <Col xs={12} sm={6}>
            <Skeleton.Input active size="small" style={{ width: '100%', height: 40 }} />
          </Col>
        </Row>
      </Card>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <Card title="Статистика задач" style={{ marginBottom: 16, marginTop: 16 }}>
      <Row gutter={16}>
        <Col xs={12} sm={6}>
          <Statistic
            title="Активные задачи"
            value={data.activeTasks}
            prefix={<ClockCircleOutlined />}
            valueStyle={{ color: '#1890ff' }}
          />
        </Col>
        <Col xs={12} sm={6}>
          <Statistic
            title="Просроченные"
            value={data.overdueTasks}
            prefix={<ExclamationCircleOutlined />}
            valueStyle={{ color: data.overdueTasks > 0 ? '#ff4d4f' : '#52c41a' }}
          />
        </Col>
        <Col xs={12} sm={6}>
          <Statistic
            title="На сегодня"
            value={data.todayTasks}
            prefix={<CalendarOutlined />}
            valueStyle={{ color: '#722ed1' }}
          />
        </Col>
        <Col xs={12} sm={6}>
          <Statistic
            title="На неделю"
            value={data.weekTasks}
            prefix={<CheckCircleOutlined />}
            valueStyle={{ color: '#52c41a' }}
          />
        </Col>
      </Row>
    </Card>
  );
};

export default TaskStats; 